'use strict';

/**
 * Fires a Google Analytics (GA) event by pushing the event and associated data to the `dataLayer`.
 *
 * @param {string} event - The name of the event to be fired. This is used to identify the type of event in GA.
 * @param {Object} data - The ecommerce data associated with the event. This object contains details about the event.
 */
const trackGAEvent = (event, data) => {
    if (event) {
        const eventObject = {
            event: event
        }
        
        if (data) {
            eventObject.ecommerce = data;
        }
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventObject);
    }
}

/**
 * Reports an event for Salesforce Commerce Cloud (SFCC) analytics by sending an AJAX GET request to the specified URL.
 * @param {string} url - The url to report (e.g., 'shipping', 'payment', etc.).
 * @returns {void}
 */
const reportSFCCEvent = (url) => {
    if (!url) {
        console.warn('URL not defined for SFCC event reporting');
        return;
    }

    $.ajax({
        url: url,
        type: 'get',
        error: function (err) {
            console.error('Error reporting SFCC event:', err);
        }
    });  
}

/**
 * Reports a checkout event for a specific step by sending a request to the corresponding reporting URL.
 *
 * @param {string} step - The checkout step to report (e.g., 'shipping', 'payment', etc.).
 * @returns {void}
 */
const reportCheckoutEvent = (step) => {
    if (!step) {
        console.warn('Step not defined');
        return;
    }

    const reportingURLsHolder = $('.reporting-url-holder');
    if (!reportingURLsHolder.length) {
        console.warn('Reporting URLs holder not found');
        return;
    }

    let url = reportingURLsHolder.data('url');
    if (!url || !url.length) {
        console.warn('Reporting URL not found');
        return;
    }

    const basketUUID = reportingURLsHolder.data('basket-uuid');
    if (!basketUUID || !basketUUID.length) {
        console.warn('Basket UUID not found');
        return;
    }

    url += `?basketUUID=${basketUUID}&step=${step}`;

    reportSFCCEvent(url);
}


module.exports = {
    trackEvent: trackGAEvent,
    reportCheckoutEvent: reportCheckoutEvent
}